import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
/* empty css                             */
const ProductDetailDisclaimer = ({ className, disclaimer }) => {
  const titleId = React.useId();
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: classnames("product-detail-disclaimer", className),
      "aria-labelledby": titleId
    },
    /* @__PURE__ */ React.createElement("div", { className: "product-detail-disclaimer__header" }, /* @__PURE__ */ React.createElement(Icon, { className: "product-detail-disclaimer__icon", name: "info", "data-t": "disclaimer-icon" }), /* @__PURE__ */ React.createElement(
      Heading,
      {
        id: titleId,
        variant: "subheading1",
        component: "h3",
        className: "product-detail-disclaimer__title"
      },
      disclaimer.title
    )),
    /* @__PURE__ */ React.createElement("div", { className: "product-detail-disclaimer__description" }, disclaimer.description)
  );
};
export {
  ProductDetailDisclaimer
};
//# sourceMappingURL=ProductDetailDisclaimer.js.map
